import { render } from "./Workflows.vue?vue&type=template&id=25aa2193&scoped=true"
import script from "./Workflows.vue?vue&type=script&lang=js"
export * from "./Workflows.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25aa2193"]])

export default __exports__